function isNativeApp() {
  return document.documentElement.hasAttribute('data-turbo-native-app');
}

function sendBridgeMessage(eventName, data = {}) {
  if (!isNativeApp()) return;

  // Android - use Hotwire Native bridge
  if (window.HotwireNative?.web) {
    window.HotwireNative.web.send({
      component: "nativeApp",
      event: eventName,
      data: {
        ...data,
        metadata: { url: window.location.href }
      }
    });
  }
  // iOS - use WebKit message handlers
  if (window.webkit?.messageHandlers?.nativeApp) {
    window.webkit.messageHandlers.nativeApp.postMessage({ name: eventName, ...data });
  }
}

function setupNativeShare() {
  if (!isNativeApp()) return;

  document.querySelectorAll('.trigger-native-share:not([data-share-initialized])').forEach(element => {
    element.addEventListener('click', () => {
      sendBridgeMessage("trigger_share", { url: element.dataset.shareUrl });
    });
    element.setAttribute('data-share-initialized', 'true');
  });
}

// Clear init attributes before Turbo caches the page
// so event listeners get re-added when restoring from cache
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll('[data-share-initialized]').forEach(element => {
    element.removeAttribute('data-share-initialized');
  });
});

document.addEventListener("turbo:load", setupNativeShare);
document.addEventListener('turbo:frame-load', setupNativeShare);


